import { render, staticRenderFns } from "./FileSystem.vue?vue&type=template&id=f59bfb88&scoped=true&"
import script from "./FileSystem.vue?vue&type=script&lang=ts&"
export * from "./FileSystem.vue?vue&type=script&lang=ts&"
import style0 from "./FileSystem.vue?vue&type=style&index=0&id=f59bfb88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59bfb88",
  null
  
)

export default component.exports